import { ValidationError } from '../../gs-core/common/models';

export type DocFormat = 'PDF';

export const DocFormats = {
  PDF: 'PDF' as DocFormat,

  parse(code: DocFormat | string): DocFormat {
    if (!code || !code.toUpperCase || code.toUpperCase() !== DocFormats.PDF) {
      throw new ValidationError(`Invalid doc format ${code}`) ;
    }

    return this[code.toUpperCase()];
  },

  toMime(format: DocFormat): string {
    const formatToMime = {
      [DocFormats.PDF]: 'application/pdf'
    };

    const mime = formatToMime[format];

    if (!mime) {
      throw new Error(`Doc format ${format} missing mime type`);
    }

    return mime;
  },
};



// WEBPACK FOOTER //
// ./src/common/models/DocFormat.ts